<template>
  <v-col
    cols="12"
  >
    <v-row>
      <v-col
        cols="6"
        class="text-field-token"
      >
        <v-text-field
          v-model="integrationToken"
          disabled="true"
          :label="$t('components.config.IntegrationToken.label.description')"
        />
      </v-col>
      <v-row
        no-gutters
      >
        <CopyToClipboard
          :content="integrationToken"
        />
      </v-row>
    </v-row>
  </v-col>
</template>

<script>
import CopyToClipboard from '@/components/CopyToClipboard';
import { mapGetters } from 'vuex';
export default {
  name: 'IntegrationToken',
  components: {
    CopyToClipboard,
  },
  data() {
    return {
      integrationToken: '',
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'getIntegrationToken',
    ]),
  },
  mounted() {
    this.integrationToken = this.getIntegrationToken || '';
  },
};
</script>
